import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryClient } from '.';
import { type Config, type EditConfig } from '../../shared/types';
import { deleteAdminConfig, getAdminConfigs, postAdminConfig, putAdminConfig } from '../utilities/api';

export const queryKeys = {
    getAdminConfigs: () => ['admin', 'configs', 'get'],
};

export const useAdminConfigs = (): UseQueryResult<Config[], Error> => {
    return useQuery({ queryKey: queryKeys.getAdminConfigs(), queryFn: getAdminConfigs, staleTime: Infinity });
};

export const useUpdateAdminConfig = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditConfig }) => putAdminConfig(id, data),
        onSuccess: (newConfig: Config) => {
            queryClient.setQueryData(queryKeys.getAdminConfigs(), (configs: Config[]) => {
                return configs.map((config) => (config._id === newConfig._id ? newConfig : config));
            });
        },
    });
};

export const useCreateAdminConfig = () => {
    return useMutation({
        mutationFn: (data: EditConfig) => postAdminConfig(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getAdminConfigs() }),
    });
};

export const useDeleteAdminConfig = () => {
    return useMutation({
        mutationFn: (id: string) => deleteAdminConfig(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAdminConfigs() });
        },
    });
};
